import { Field } from 'module/api/field/types';
import { IntegrationField } from 'module/api/integrations/salesforce/types';
import { filterableFieldType } from 'module/helpers/filter/type-transformers';
import { getRandomColor } from 'module/helpers/get-random-color';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';

export const convertIntegrationFieldToField = (fields: IntegrationField[]) => {
  const fieldLabelCounts = fields.reduce<Record<string, number>>((acc, f) => {
    const label = (f.fieldLabel ?? '').trim();
    if (!label) return acc;
    acc[label] = (acc[label] ?? 0) + 1;
    return acc;
  }, {});

  return fields.map((field) => {
    const baseLabel = field.fieldLabel;
    const normalized = (baseLabel ?? '').trim();
    const needsDisambiguation =
      Boolean(normalized) && (fieldLabelCounts[normalized] ?? 0) > 1;

    return {
      ...field,
      fieldId: field.integrationFieldId,
      // Keep label as-is; render disambiguation pill separately in the dropdown
      fieldLabel: baseLabel,
      integrationFieldId: undefined,
      type: filterableFieldType(field as unknown as Field),
      metaData: {
        ...(field.metaData ?? {}),
        pillText:
          needsDisambiguation && field.integrationFieldId != null
            ? String(field.integrationFieldId)
            : undefined,
        options: field.metaData?.options?.map((option) => ({
          ...option,
          value: option.valueStr,
          color: option.color ?? getRandomColor(option.label),
        })),
      },
    } as unknown as FilterableField;
  });
};
